import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getPowerGenerationHourMeterList,
	addNewPowerGenerationHourMeter,
	updatePowerGenerationHourMeter,
	deletePowerGenerationHourMeter,
	getPowerGenerationHourMeter,
} from '../powerGenerationHourMeter/thunk';

export const initialState = {
	itemPowerGenerationHourMeterList: [],
	itemPowerGenerationHourMeterDetail: null,
	isPowerGenerationHourMeterLoading: false,
	isPowerGenerationHourMeterSuccess: false,


	powerGenerationHourMeterList: [],
	powerGenerationHourMeterListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const PowerGenerationHourMeterSlice = createSlice({
	name: 'PowerGenerationHourMeter',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getPowerGenerationHourMeter.fulfilled, (state, action) => {
			state.isPowerGenerationHourMeterLoading = false;
			state.isPowerGenerationHourMeterSuccess = true;
			state.itemPowerGenerationHourMeterDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getPowerGenerationHourMeter.pending, state => {
			state.isPowerGenerationHourMeterLoading = true;
			state.isPowerGenerationHourMeterSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getPowerGenerationHourMeter.rejected, (state, action) => {
			state.isPowerGenerationHourMeterLoading = false;
			state.isPowerGenerationHourMeterSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getPowerGenerationHourMeterList.pending, state => {
			state.isPowerGenerationHourMeterSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPowerGenerationHourMeterList.fulfilled, (state, action) => {
			state.itemPowerGenerationHourMeterList = action.payload;
			state.powerGenerationHourMeterList = action.payload;
			state.isLoadingList = false;
			state.isPowerGenerationHourMeterSuccess = true;

			let powerGenerationHourMeterListSelect = [];
			action.payload.map(item =>
				powerGenerationHourMeterListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.powerGenerationHourMeterListSelect = powerGenerationHourMeterListSelect;
		});
		builder.addCase(getPowerGenerationHourMeterList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPowerGenerationHourMeterSuccess = true;
		});
		builder.addCase(addNewPowerGenerationHourMeter.fulfilled, (state, action) => {
			state.itemPowerGenerationHourMeterList.push(action.payload);
			state.powerGenerationHourMeterList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewPowerGenerationHourMeter.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPowerGenerationHourMeter.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updatePowerGenerationHourMeter.fulfilled, (state, action) => {
			state.itemPowerGenerationHourMeterList = state.itemPowerGenerationHourMeterList.map(powerGenerationHourMeter =>
				powerGenerationHourMeter.powerGenerationHourMetername === action.payload.old_powerGenerationHourMeter
					? { ...powerGenerationHourMeter, ...action.payload.updated_powerGenerationHourMeter }
					: powerGenerationHourMeter
			);
			state.powerGenerationHourMeterList = state.powerGenerationHourMeterList.map(powerGenerationHourMeter =>
				powerGenerationHourMeter._id.toString() === action.payload._id.toString()
					? { ...powerGenerationHourMeter, ...action.payload }
					: powerGenerationHourMeter
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updatePowerGenerationHourMeter.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePowerGenerationHourMeter.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deletePowerGenerationHourMeter.fulfilled, (state, action) => {
			state.itemPowerGenerationHourMeterList = current(state.itemPowerGenerationHourMeterList).filter(
				item => item._id !== action.payload._id
			);
			state.powerGenerationHourMeterList = current(state.powerGenerationHourMeterList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deletePowerGenerationHourMeter.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deletePowerGenerationHourMeter.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = PowerGenerationHourMeterSlice.actions;

export default PowerGenerationHourMeterSlice.reducer;
